import { useEffect, useState } from "react";

/**
 * Hook: returns a boolean reflecting the user's `prefers-reduced-motion`
 * preference. Updates live if the OS-level setting changes.
 *
 * Shared extraction of the hook previously duplicated inside
 * AnimatedBackground and animated-beam; new code should import this one.
 */
const useReducedMotion = () => {
  const [reduced, setReduced] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
    const handler = (e) => setReduced(e.matches);
    if (mql.addEventListener) {
      mql.addEventListener("change", handler);
      return () => mql.removeEventListener("change", handler);
    }
    // Safari < 14 fallback
    mql.addListener(handler);
    return () => mql.removeListener(handler);
  }, []);

  return reduced;
};

export default useReducedMotion;
